<template>
  <div class="sbgl_content">
    <el-row type="flex" justify="space-around" style="width: 100%; height: 20%">
      <div class="sbgl_block">
        <img :src="imgs.img01" alt="" />
        <div class="sbgl_box">
          <countTo
            class="sbgl_count"
            :startVal="0"
            :endVal="form.functionNum"
            :duration="3000"
          ></countTo>
          <img :src="imgs.img_line_small" alt="" class="sbgl_line" />
          <span class="sbgl_desc">运行总数</span>
        </div>
      </div>
      <div class="sbgl_block">
        <img :src="imgs.img02" alt="" />
        <div class="sbgl_box">
          <countTo
            class="sbgl_count"
            :startVal="0"
            :endVal="form.shutDownNum"
            :duration="3000"
          ></countTo>
          <img :src="imgs.img_line_small" alt="" class="sbgl_line" />
          <span class="sbgl_desc">待机数量</span>
        </div>
      </div>
      <div class="sbgl_block">
        <img :src="imgs.img03" alt="" />
        <div class="sbgl_box">
          <countTo
            class="sbgl_count"
            :startVal="0"
            :endVal="form.maintainedNum"
            :duration="3000"
          ></countTo>
          <img :src="imgs.img_line_big" alt="" class="sbgl_line" />
          <span class="sbgl_desc">未来一月内待保养数量</span>
        </div>
      </div>
      <div class="sbgl_block">
        <img :src="imgs.img04" alt="" />
        <div class="sbgl_box">
          <countTo
            class="sbgl_count"
            :startVal="0"
            :endVal="form.repairedNum"
            :duration="3000"
          ></countTo>
          <img :src="imgs.img_line_small" alt="" class="sbgl_line" />
          <span class="sbgl_desc">待维修数量</span>
        </div>
      </div>
    </el-row>
    <el-row
      type="flex"
      justify="space-around"
      style="width: 90%; height: 30%; margin: 5px auto"
    >
      <div class="sbgl_center_start">
        <img :src="imgs.img_center_top01" alt="" class="sbgl_animation" />
        <img :src="imgs.img_center_bottom" alt="" />
      </div>
      <div class="sbgl_center_end">
        <img :src="imgs.img_center_top02" alt="" class="sbgl_animation" />
        <img :src="imgs.img_center_bottom" alt="" />
      </div>
      <div class="sbgl_center_start">
        <img :src="imgs.img_center_top03" alt="" class="sbgl_animation" />
        <img :src="imgs.img_center_bottom" alt="" />
      </div>
      <div class="sbgl_center_end">
        <img :src="imgs.img_center_top02" alt="" class="sbgl_animation" />
        <img :src="imgs.img_center_bottom" alt="" />
      </div>
      <div class="sbgl_center_start">
        <img :src="imgs.img_center_top04" alt="" class="sbgl_animation" />
        <img :src="imgs.img_center_bottom" alt="" />
      </div>
      <div class="sbgl_center_end">
        <img :src="imgs.img_center_top02" alt="" class="sbgl_animation" />
        <img :src="imgs.img_center_bottom" alt="" />
      </div>
    </el-row>
    <el-row type="flex" justify="space-around" style="width: 100%; height: 50%">
      <el-col :span="24">
        <div class="zlgl_title"><span>设备开工率</span></div>
        <div
          id="chart03"
          ref="chartRefLine"
          style="width: 100%; height: 85px"
        ></div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import * as echarts from 'echarts'
import countTo from 'vue-count-to'
import { getDeviceStatusCount, getOrderStatusCount, getOperatingRate } from '@/api/index'
export default {
  components: {
    countTo
  },
  data () {
    return {
      imgs: {
        img01: require('@/assets/imgs/yxzs.png'),
        img02: require('@/assets/imgs/djsl.png'),
        img03: require('@/assets/imgs/wl.png'),
        img04: require('@/assets/imgs/dwxsl.png'),
        img_line_small: require('@/assets/imgs/djslbg.png'),
        img_line_big: require('@/assets/imgs/wlbg.png'),
        img_center_bottom: require('@/assets/imgs/jq.png'),
        img_center_top01: require('@/assets/imgs/red.png'),
        img_center_top02: require('@/assets/imgs/yellow.png'),
        img_center_top03: require('@/assets/imgs/gray.png'),
        img_center_top04: require('@/assets/imgs/green.png'),
      },
      form: {
        functionNum: 0,
        shutDownNum: 0,
        maintainedNum: 0,
        repairedNum: 0
      },
      rateList: []
    }
  },
  mounted () {
    this.getDeviceStatusCounts()
    this.getOrderStatusCounts()
    this.getOperatingRates()
    /**接口没发布 图表数据有问题 */
  },
  methods: {
    setOpenCloseCharts () {
      const theEcharts = echarts.init(this.$refs.chartRefLine, 'dark');
      const options = {
        grid: {
          left: '0%',    // 去除左侧间距
          right: '0%',   // 去除右侧间距
          bottom: '0%',  // 去除底部间距
          top: '10%',     // 去除顶部间距
          containLabel: true // 如果使用 `containLabel: true`，则会根据标签大小自动调整间距，保证标签内容不被裁剪
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        xAxis: {
          type: 'category',
          data: this.rateList.map(item => item.currentMonth),
        },
        yAxis: {
          type: 'value',
          min: 0,
          max: 100,
          interval: 20,
          axisLabel: {
            formatter: '{value}%'
          }
        },
        series: [
          {
            data: this.rateList.map(item => item.rate * 100),
            type: 'line',
            smooth: true,
            areaStyle: {
              opacity: 0.3
            },
            markPoint: {
              data: [
                // 标记第三个点
                // { type: 'max', name: '最大值' },
                { type: 'min', name: '最小值' }
              ]
            }
          }
        ]
      }
      // 渲染图表
      theEcharts.setOption(options)
    },
    async getDeviceStatusCounts () {
      let result = await getDeviceStatusCount({})
      console.log(result)
      if (result.code == 200) {
        this.$set(this, 'form', result.data)
      }
    },
    async getOrderStatusCounts () {
      let result = await getOrderStatusCount({})
      console.log(result)
      if (result.code == 200) {
        this.$set(this.form, 'maintainedNum', result.data.maintainedNum)
        this.$set(this.form, 'repairedNum', result.data.repairedNum)
      }
    },
    async getOperatingRates () {
      let result = await getOperatingRate({})
      console.log(result)
      if (result.code == 200) {
        this.$set(this, 'rateList', result.data)
        this.setOpenCloseCharts()
      }
    },
  }
}
</script>
<style lang="scss" scoped>
.sbgl_content {
  width: 100%;
  height: calc(100% - 20px);
  display: flex;
  align-content: flex-start;
  flex-wrap: wrap;
  .sbgl_block {
    width: 25%;
    display: flex;
    justify-content: center;
    align-items: center;
    .sbgl_box {
      height: 70%;
      padding-left: 3px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-content: space-between;
      position: relative;
      .sbgl_desc {
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 12px;
        color: #ffffff;
      }
      .sbgl_line {
        position: absolute;
        top: 12px;
      }
      .sbgl_count {
        text-align: center;
        font-family: DIN;
        font-weight: bold;
        font-size: 20px;
        color: #ffffff;
        z-index: 2;
      }
    }
  }
  .zlgl_title {
    width: 100%;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    text-align: center;
    padding-bottom: 5px;
  }
  .sbgl_center_start {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
  }
  .sbgl_center_end {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
  }
  .sbgl_animation {
    animation: breathLamp 2s alternate infinite;
  }
}

@keyframes breathLamp {
  // 0% {
  //   opacity: 0.2;
  // }
  // 100% {
  //   opacity: 1;
  // }
  0% {
    transform: scale(0.9);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(0.9);
  }
}
</style>